const MODAL_ACTION_CLOSE = { type: 'close' };
const MODAL_ACTION_OPEN = { type: 'open' };

export { MODAL_ACTION_CLOSE, MODAL_ACTION_OPEN };
//# sourceMappingURL=constants.js.map
